import React, { useCallback } from 'react';
import { useAssignOwnerContext, openAssignOwnerModal } from 'modules/tasks/assign-owner/context';
import { useSelectedTasksContext } from 'modules/tasks/lists/context';
import { FormattedPlural } from 'react-intl';

const t = {
  assign: 'Assign ',
  selected: 'selected ',
  create: 'Add new task',
  job: 'job',
  jobs: 'jobs',
};

const ActionButton = ({ className, setShowCreateTask }) => {
  const { selected } = useSelectedTasksContext();
  const { dispatch } = useAssignOwnerContext();

  const numberOfSelectedTasks = selected?.length;

  const handleCreateTask = useCallback(() => {
    setShowCreateTask(true);
  }, [setShowCreateTask]);

  const handleAssignTasks = useCallback(() => {
    dispatch(openAssignOwnerModal({ journeyIds: selected }));
  }, [dispatch, selected]);

  return (
    <>
      {!numberOfSelectedTasks && (
        <div className={className}>
          <button className="button button-create" onClick={handleCreateTask}>
            {t.create}
          </button>
        </div>
      )}
      {!!numberOfSelectedTasks && (
        <div className={className}>
          <button className="button button-assign" onClick={handleAssignTasks}>
            <>
              {t.assign} {numberOfSelectedTasks} {t.selected}
              <FormattedPlural value={numberOfSelectedTasks} one={t.job} other={t.jobs} />
            </>
          </button>
        </div>
      )}
    </>
  );
};

export default ActionButton;
